import { lazy, useState } from 'react';
import { getLoadedLoginPage, loadLoginPage } from '../utils/loadLoginPage';

const LazyLogin = lazy(loadLoginPage);

export const LoginRoute = () => {
  // A fulfilled preload can render directly without a first lazy suspension.
  // Keep the choice stable if an import settles after this route mounts, so
  // unrelated parent renders cannot remount the form and reset input/focus.
  const [Component] = useState(() => getLoadedLoginPage() ?? LazyLogin);
  return <Component />;
};
